module.exports = __webpack_public_path__ + "static/media/gk_com_2.8d2edb12.jpg";